import { type ChangeEventHandler, type ComponentProps, forwardRef } from "react";

import { cn } from "../utils";
import { Button } from "./button";
import { Icon } from "./icon";

export interface SearchInputProps extends ComponentProps<"input"> {
  onValueChange?: (value: string) => void;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, type, onValueChange, onChange, value = "", ...props }, ref) => {
    const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
      onValueChange?.(event.target.value);
      onChange?.(event);
    };

    const onClear = () => {
      onValueChange?.("");
    };

    return (
      <div className="relative">
        <Icon icon="search" className="absolute bottom-0 left-3 m-auto text-muted-foreground text-sm top-0" />
        <input
          ref={ref}
          type="search"
          {...props}
          value={value}
          onChange={handleChange}
          className={cn(
            "rounded-3xl bg-foreground/5 border-0 font-normal h-8 pl-8 pr-8 py-2 text-xs focus-visible:outline-hidden placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 [&::-webkit-search-decoration]:hidden [&::-webkit-search-cancel-button]:hidden [&::-webkit-search-results-button]:hidden [&::-webkit-search-results-decoration]:hidden",
            className
          )}
        />
        {!!value && String(value).length > 0 && (
          <Button
            variant="unstyled"
            size="xs"
            display="icon"
            onClick={onClear}
            className="absolute bottom-0 right-1 m-auto top-0 text-sm text-muted-foreground"
          >
            <Icon icon="close" />
          </Button>
        )}
      </div>
    );
  }
);
SearchInput.displayName = "SearchInput";
